let apis = {
    local: {
        regionUrl: "https://services.smartbear.team/api/pricing-zone",
        interpriceUrl: "/data/interprice.json",
        productsUrl: "/data/products.json",
        solutionsUrl: "/data/solutions.json",
        platformsUrl: "/data/platforms.json",
        marketPlaceUrl: "/data/marketplaces.json"
    },
    staging: {
        regionUrl: "https://services.smartbear.team/api/pricing-zone",
        interpriceUrl: "/store/data/interprice.json",
        productsUrl: "/store/data/products.json",
        solutionsUrl: "/store/data/solutions.json",
        platformsUrl: "/store/data/platforms.json",
        marketPlaceUrl: "/store/data/marketplaces.json"
    },
    production: {
        regionUrl: "https://services.smartbear.team/api/pricing-zone",
        interpriceUrl: "/store/data/interprice.json",
        productsUrl: "/store/data/products.json",
        solutionsUrl: "/store/data/solutions.json",
        platformsUrl: "/store/data/platforms.json",
        marketPlaceUrl: "/store/data/marketplaces.json"
    }
};

/**
 * Detect current environment
 */
let currentEnv = 'local';
 if (window.location.hostname === "staging.smartbear.com") {
    currentEnv = "staging";
} else if (window.location.hostname === "smartbear.com") {
    currentEnv = "production";
}

const config = {
    env: currentEnv,    
    api: apis[currentEnv]
}

export default config;